import { CustomCollapseCard, Text } from '@src/components';
import { useSelector } from 'react-redux';
import { formatDate, moneyFormat } from '@src/utils/utils';
import dayjs from '@src/utils/day';
import { dateFormat } from '@src/utils/keys';
import { monthsList, orderTypeList } from '@src/store/enums';

const OrderSummaryInformation = () => {
    const { currentCardOrder } = useSelector((state) => state?.cardOrder);
    const getCurrentLanguage = () => localStorage.getItem('language')?.slice(1, -1);

    const isEnglish = getCurrentLanguage() === 'en';
    const invoiceMonthText = monthsList
        .filter((month) => month.value === currentCardOrder?.invoiceMonth)
        .reduce((acc, month) => month.text, '');

    const cardParemetersText = () => {
        return (
            <>
                <div className="title">
                    <span className="compliment-text1">
                        <Text t="cardPrintingOptions" />
                    </span>
                </div>
                <div className="summary-list">
                    <span className="compliment-text3">
                        {currentCardOrder?.printNameSurname ? <Text t="printWithName" /> : <Text t="printWithoutName" />}
                    </span>
                    <span className="compliment-text3">
                        {currentCardOrder?.printCompanyName ? <Text t="printWithCompanyName" /> : <Text t="printWithoutCompanyName" />}
                    </span>
                    <span className="compliment-text3">
                        {currentCardOrder?.printCompanyLogo
                            ? <Text t="printWithCompanyLogo" />
                            : <Text t="printWithoutCompanyLogo" />}
                    </span>
                </div>
            </>
        );
    };

    return (
        <CustomCollapseCard
            cardTitle={<Text t="orderSummaryTitle" />}
            cardTitleAlign="center"
            titleColor="#1d2228"
            titleSize="16px"
            showExpandIcon={false}
            className="card-order-summary-collapse"
        >
            <div className="card-summary-container">
                <div className="order-summary-col-1" style={{ flex: 2 }}>
                    <div className="title">
                        <span className="compliment-text1"><Text t="cardType2" />:</span>
                        <span className="compliment-text3">
                            {' '}
                            {currentCardOrder?.cardType === 0 ? <Text t="physical" /> : <Text t="digital" />}
                        </span>
                    </div>
                    {currentCardOrder?.cardType === 0 && cardParemetersText()}
                    {currentCardOrder?.cardType === 1 && (
                        <div className="title" style={{ width: 190 }}>
                            <span className="compliment-text1"><Text t="orderType" />:</span>
                            <span className="compliment-text3">
                                {' '}
                                {orderTypeList?.filter((oTL) => oTL.value === currentCardOrder?.orderType)[0].text}
                            </span>
                        </div>
                    )}
                </div>

                {currentCardOrder?.totalPrice > 0 && (
                    <div className="order-summary-col-2" style={{ flex: 3 }}>
                        <div className="title">
                            <span className="compliment-text1"><Text t="autoActivationDate" />:</span>
                            <span className="compliment-text2">
                                {dayjs(currentCardOrder?.cardActivationDate)
                                    .locale(isEnglish ? 'en' : 'tr')
                                    .format(dateFormat)}
                            </span>
                        </div>
                        <div className="title">
                            <span className="compliment-text1">
                                <Text t="invoiceMonth2" />
                            </span>{' '}
                            <span className="compliment-text3">{invoiceMonthText}</span>
                        </div>
                        <div className="title">
                            <span className="compliment-text1">
                                <Text t="invoiceAddress" />
                            </span>{' '}
                            <span className="compliment-text3">{currentCardOrder?.invoiceAddress}</span>
                        </div>
                        <div className="title e-invoice-information">
                            <span className="compliment-text1">
                                <Text t="eInvoiceAdditionalInformation2" />
                            </span>
                            <span className="compliment-text3">{currentCardOrder?.eInvoiceInformation}</span>
                        </div>
                    </div>
                )}

                <div className="order-summary-col-3" style={{ flex: 3 }}>
                    <div className="custom-info-box" style={{ backgroundColor: '#f2f4f5', borderRadius: 8 }}>
                        <div className="title">
                            <span className="compliment-text1"><Text t="numberOfCards3" />:</span>
                        </div>
                        <span className="compliment-text4">{currentCardOrder?.totalCount}</span>
                    </div>
                    <div className="custom-info-box" style={{ backgroundColor: '#f2f4f5', borderRadius: 8 }}>
                        <div className="title">
                            <span className="compliment-text1"><Text t="totalBalanceToBeLoadedUpperCaseColon" />:</span>
                        </div>
                        <span className="compliment-text4">
                            {moneyFormat(currentCardOrder?.totalPrice, true)}
                        </span>
                    </div>
                    <div className="custom-info-box" style={{ backgroundColor: '#f2f4f5', borderRadius: 8 }}>
                        <div className="title">
                            <span className="compliment-text1"><Text t="totalAmountToBePaid" />:</span>
                        </div>
                        <span className="compliment-text4">
                            {moneyFormat(currentCardOrder?.totalPaymentAmount, true)}
                        </span>
                    </div>
                </div>
            </div>
        </CustomCollapseCard>
    );
};

export default OrderSummaryInformation;
